/*
 * @@Author: MuYang
 */
import {getBatchAuths} from './business/auth'
import {getI18nData} from './business/i18'

// 初始化
export default async function _init ({objectApiName, region, subs, codeObjectApiname}) {
  await Promise.all([
    getBatchAuths([codeObjectApiname, ...subs], {[codeObjectApiname]: objectApiName}),
    getI18nData(objectApiName, region, subs)
  ])
  return true
}
